import { render, staticRenderFns } from "./EventTypeTabs.vue?vue&type=template&id=ffa74e1e&scoped=true&lang=html&"
import script from "./EventTypeTabs.vue?vue&type=script&lang=js&"
export * from "./EventTypeTabs.vue?vue&type=script&lang=js&"
import style0 from "./EventTypeTabs.vue?vue&type=style&index=0&id=ffa74e1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa74e1e",
  null
  
)

export default component.exports